import $ from 'jquery';
import BaseView from '../../core/baseView';

export default BaseView.extend({
  step: null,
  step1Controller: null,
  step2Controller: null,

  initialize: function(options) {
    this.step = options.step;
    this.step1Controller = options.step1Controller;
    this.step2Controller = options.step2Controller;

    if (this.$el.length > 0) {
      switch (this.step) {
        case 1:
          this.bindStep1();
          break;

        case 2:
          this.bindStep2();
          break;

        case 3:
          this.bindStep3();
          break;
      }
    }
  },

  bindStep1: function() {
    this.$('li')
      .eq(1)
      .on(
        'click',
        $.proxy(this.step1Controller.onNextClick, this.step1Controller)
      );
  },

  bindStep2: function() {
    this.$('li')
      .eq(0)
      .on('click', function() {
        document.location = $('#prevButton').attr('href');
      });

    this.$('li')
      .eq(2)
      .on(
        'click',
        $.proxy(this.step2Controller.submitForm, this.step2Controller)
      );
  },

  bindStep3: function() {
    this.$('li')
      .eq(1)
      .on('click', function() {
        document.location = $('.back.button').attr('href');
      });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/StepsView.js
 **/